/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Ship_Ammo_LaserInputs */

const ja_calendar_ship_ammo_laser = /** @type {(inputs: Calendar_Ship_Ammo_LaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーザー`)
};

const en_calendar_ship_ammo_laser = /** @type {(inputs: Calendar_Ship_Ammo_LaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LASER`)
};

/**
* | output |
* | --- |
* | "LASER" |
*
* @param {Calendar_Ship_Ammo_LaserInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_ship_ammo_laser = /** @type {((inputs?: Calendar_Ship_Ammo_LaserInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Ship_Ammo_LaserInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_ship_ammo_laser(inputs)
	return en_calendar_ship_ammo_laser(inputs)
});